import { post } from "../../service/api";

const requestCallback = async (id) => {
    try {
        const response = await post(`/invoice/${id}/requestCallback`);
        if (!response) return null;
        return response.data;
    } catch (error) {
        console.error('Error requestCallback:', error);
        throw error;
    }
};

export default requestCallback;